export class Job {
  appPropJson: string;
  number: number;
  name: string;
  maxCores: number;
  minCores: number;
  state: string;
  stage: string;
  status: string;
  user: string;
  nodelist: string;
  autoScheduled: string;
  iterationNumber: string;
  iterationCount: string;
  iterationInterval: string;
  isPlottable: boolean;
  deployment: string;
  application: string;
  version: string;
  startTime: string;
  executionStartTime: string;
  totalTime: string;
  endTime: string;
  runTime: string;
  inputFileList: string;
  outputFile: string;
  dataBackup: string;
  downloadState: string;
  totalDownloadSize: string;
  downloadedSize: string;
  autoShut: string;
  stopAllocated: string;
  unitsUsed: string;
  workDirectory: string;
  outputDirectory: string;
  description: string;
  remark: string;
  priority: string;
  isSuspended: boolean;
  jobActions: JobAction[];
  jobTotalExecutionTime?: string;
  jobTotalWaitTime?: string;
  jobInformation?: string;
  jobLifeSpan?: string;
  jobTotalCoreUsed?: string;
  jobTag: string;
  customTag: string;
  isHeld: boolean;
  jobInitEntryTime: string;
  JobDataCopyEntryTime: string;
  jobSubmitEntryTime: string;
  userGroup: string | null;
  jobTemplate: string;
  partition: string;
  schedulerJobId: string;
  jobHandler: string;
  jobCanelRequest: boolean;
  localStorePath: string;
  isLocalStore: boolean;
  podNames: string;
  assignedStorage: string;
}

export interface JobTemplate {
  templateId: string;
  userId: string;
  deploymentId: string;
  templateName: string;
  application: string;
  applicationVersion: string;
  appSettings: string;
}

export class JobAction {
  actionName: string;
  actionValue: number;

  constructor(name, value) {
    this.actionName = name;
    this.actionValue = value;
  }
}

export interface ApplicationVersionDictionary {
  [key: string]: string[];
}

export enum JobActionsText {
  TxtActions = "Actions",
  TxtCancel = "Cancel Job",
  TxtCancelRepeat = "Cancel Repetition",
  TxtInfo = "Job Details",
  TxtOutput = "Show Output",
  TxtGraph = "Monitor Graph",
  TxtEnableDownload = "Enable Auto Download",
  TxtCancelDownload = "Cancel Auto Download",
  TxtReEnableDownload = "Re-enable Auto Download",
  TxtResubmit = "Resubmit Job",
  TxtEnableAutoShut = "Enable AutoShut",
  TxtDisableAutoShut = "Disable AutoShut",
  TxtDelete = "Delete Job",
  TxtStopAllocatedNodes = "Enable Stop Allocated Nodes",
  TxtDisableStopAllocatedNodes = "Disable Stop Allocated Nodes",
  TxtDataDelete = "Delete Job Data",
  TxtJobSchedule = "Job Schedule",
  TxtJobRevive = "Job Revival",
  TxtJobSubmit = "Submit Job",
  TxtJobDetailsDownload = "Job Details Download",
  TxtAllJobsDetailsDownload = "All Jobs Details Download",
  TxtChangeJobPriority = "Change Job Priority",
  TxtChangeJobPartition = "Change Job Partition",
  TxtRunCommand = "Run Command",
  TxtSuspendJob = "Suspend Job",
  TxtResumeJob = "Resume Job",
  TxtInactiveJob = "Force Inactive",
  TxtHoldJob = "Hold Job",
  TxtReleaseJob = "Release Job",
  TxtDeleteJobWorkstoreData = "Delete Job Workstore Data",
  TxtDeleteJobSyncstoreData = "Delete Job Syncstore Data",
  TxtConnectToPod = "Connect to Pod",
}

export enum JobActionsValue {
  ValActions = -1,
  ValCancel = 0,
  ValCancelRepeat = 1,
  ValInfo = 2,
  ValOutput = 3,
  ValGraph = 4,
  ValEnableDownload = 5,
  ValCancelDownload = 6,
  ValReEnableDownload = 7,
  ValResubmit = 8,
  ValEnableAutoShut = 9,
  ValDisableAutoShut = 10,
  ValDelete = 11,
  ValStopAllocatedNodes = 12,
  ValDisableStopAllocatedNodes = 13,
  ValDataDelete = 14,
  ValJobSchedule = 15,
  ValJobRevive = 16,
  ValJobSubmit = 17,
  ValJobDetailsDownload = 18,
  ValAllJobsDetailsDownload = 19,
  ValChangeJobPriority = 20,
  ValRunCommand = 21,
  ValSuspendJob = 22,
  ValResumeJob = 23,
  ValInactiveJob = 24,
  ValHoldJob = 25,
  ValReleaseJob = 26,
  ValDeleteJobWorkstoreData = 31,
  ValDeleteJobSyncstoreData = 32,
  ValConnectToPod = 33,
  ValChangeJobPartition = 34
}

export enum JobPriorityText {
  Highest = "Highest",
  AboveNormal = "Above Normal",
  Normal = "Normal",
  BelowNormal = "Below Normal",
  Lowest = "Lowest",
}

export enum OutputDownloadState {
  Disabled = -1,
  Enabled = 0,
  InProgress = 1,
  Completed = 2,
  Failed = 3,
  Cancelled = 4,
  Unknown = 5,
}

export enum OutputDownloadStatus {
  Disabled = "Disabled",
  Enabled = "Enabled",
  InProgress = "In Progress",
  Completed = "Completed",
  Failed = "Failed",
  Cancelled = "Cancelled",
  Unknown = "Wait...",
}

export interface AbaqusJobTypes {
  name: string;
  value: string;
}

export class JobUploadFieldType {
  fileName: string;
  filePath: string;
  uploadFieldName: string;
  uploadValue: string;

  constructor(
    name: string,
    path: string,
    fieldName: string,
    uploadValue: string
  ) {
    this.fileName = name;
    this.filePath = path;
    this.uploadFieldName = fieldName;
    this.uploadValue = uploadValue;
  }
}

export enum JobPriorityVal {
  Highest = 0, //"Highest"
  AboveNormal = 1, //"Above Normal"
  Normal = 2, //"Normal"
  BelowNormal = 3, //"Below Normal"
  Lowest = 4, //"Lowest"
}

export enum JobGlobalState {
  Inactive = "Inactive",
  Active = "Active",
  Delete = "Delete",
}

export interface JobDirectoryPathsI {
  syncStorePath: string;
  workStorePath: string;
}

export interface JobCountData {
  timeStamp: string;
  totalJobCount: number;
  succeededCount: number;
  failedCount: number;
  cancelledCount: number;
}

export interface JobCountPerDay {
  time: string;
  count: number;
}

export class ImportJobsDTO {
  JobId: string = '';
  UserId: string = '';
  NumberOfCores: string = '';
  Application: string = '';
  AllocatedNodes: string = '';
  CreateTime: string = '';
  StartTime: string = '';
  EndTime: string = '';
  Partition: string = '';
  State: string = '';
  Tag: string = '';
  CustomTag: string = '';
  RUN_Time: string = '';
  Wait_Time: string = '';
  Run_Time_Sec: string = '';
  Wait_Time_Sec: string = '';
  Wait_Time_Hour: string = '';
  Run_Time_Hour: string = '';
}
